import React from 'react';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import UndoIcon from '@mui/icons-material/Undo';
import PendingIcon from '@mui/icons-material/Pending';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';

export const getPaymentStatusIcon = status => {
  switch (status) {
    case 'initiated':
      return (
        <Tooltip title='Zahlung gestartet'>
          <PendingIcon color='info' />
        </Tooltip>
      );
    case 'pending':
      return (
        <Tooltip title='Zahlung wartet auf Bestätigung'>
          <AccessTimeIcon color='info' />
        </Tooltip>
      );
    case 'authorised':
      return (
        <Tooltip title='Zahlung autorisiert'>
          <HowToRegIcon color='success' />
        </Tooltip>
      );
    case 'captured':
      return (
        <Tooltip title='Zahlung vollständig abgeschlossen'>
          <DoneAllIcon color='success' />
        </Tooltip>
      );
    case 'processed':
      return (
        <Tooltip title='Zahlung erfolgreich'>
          <CheckCircleIcon color='success' />
        </Tooltip>
      );
    case 'refunded':
      return (
        <Tooltip title='Vollständig zurückerstattet'>
          <UndoIcon color='warning' />
        </Tooltip>
      );
    case 'partialRefund':
      return (
        <Tooltip title='Teilweise zurückerstattet'>
          <UndoIcon color='warning' />
        </Tooltip>
      );
    case 'failed':
      return (
        <Tooltip title='Zahlung fehlgeschlagen'>
          <ErrorOutlineIcon color='error' />
        </Tooltip>
      );
    case 'cancelled':
      return (
        <Tooltip title='Zahlung abgebrochen'>
          <CancelIcon color='error' />
        </Tooltip>
      );
    case 'timeout':
      return (
        <Tooltip title='Zahlung abgebrochen'>
          <RunningWithErrorsIcon color='error' />
        </Tooltip>
      );
    default:
      return null;
  }
};

export const getRefundStatusIcon = status => {
  switch (status) {
    case 'processed':
      return (
        <Tooltip title='Erstattung erfolgreich'>
          <CheckCircleIcon color='success' />
        </Tooltip>
      );
    case 'failed':
      return (
        <Tooltip title='Erstattung fehlgeschlagen'>
          <ErrorOutlineIcon color='error' />
        </Tooltip>
      );
    case 'initiated':
      return (
        <Tooltip title='Erstattung in Bearbeitung'>
          <PendingIcon color='info' />
        </Tooltip>
      );
    default:
      return null;
  }
};
